import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as PortfolioRootCreators } from "modules/portfolio-root/model"
import { Creators as ProfileCreators } from "model/profileModal"
import { getSelectedDate, getEarliestDate, getLatestDate, getStartDate, getEndDate, getDriftDates, getIsPeriodIntraday } from "modules/security-profile/selectors/dates"
import { getOptions, getFilteredData, getCategoryItemsSubset } from "./selectors/data"
import { getDisplayType } from "./selectors/items"
import { computePositionSet, getSingleDateBase } from "modules/security-profile/helpers/security"
import { getExposureAttributionData, getFirstHistoricalExposureDate, getMaxFactors } from "./selectors/exposure"
import { getDetails } from "./selectors/details"

const exposureFactorsSubQuery = "factors { id name category net }"

export default createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    driftDates: getDriftDates(state, props),
    startDate: getStartDate(state, props),
    endDate: getEndDate(state, props),
    selectedDate: getSelectedDate(state, props),
    isPeriodIntraday: getIsPeriodIntraday(state, props),
  }),
  required: ["account", "modelId"],
  data: [{
    resource: "securityExposureHistory",
    url: ({ modelId, security: { assetClass, ticker, mic, modelProviderId }, base, driftDates, startDate, endDate, isPeriodIntraday }) => {
      if (isPeriodIntraday) {
        base = getSingleDateBase(base, endDate)

        return {
          id: `securityExposureHistory-intraday-${modelId}${ticker}${mic}${endDate}${JSON.stringify(base)}`,
          query: `query ($modelId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $endDate: Date!) {
          model (id: $modelId) {
            intradaySimulation(positionSet: $positionSet, base: $base, on: $endDate) {
              exposure {
                date: timestamp
                ${exposureFactorsSubQuery}
              }
            }
          }
        }`,
          variables: {
            modelId,
            positionSet: {
              dates: [{
                date: endDate,
                ...computePositionSet(assetClass, ticker, mic, modelProviderId),
              }],
            },
            base,
            endDate,
          },
        }
      }

      const from = startDate < driftDates.startDate ? startDate : driftDates.startDate
      const to = driftDates.endDate

      base = getSingleDateBase(base, from)

      return {
        id: `securityExposureHistory-${modelId}${ticker}${mic}${startDate}${endDate}${JSON.stringify(base)}`,
        query: `query ($modelId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $from: Date!, $to: Date!) {
          model (id: $modelId) {
            simulation(positionSet: $positionSet, base: $base, from: $from, to: $to, interval: AUTO) {
              exposure {
                date
                ${exposureFactorsSubQuery}
              }
            }
          }
        }`,
        variables: {
          modelId,
          positionSet: {
            dates: [{
              date: startDate,
              ...computePositionSet(assetClass, ticker, mic, modelProviderId),
            }],
          },
          base,
          from,
          to,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    earliestDate: getEarliestDate(state),
    latestDate: getLatestDate(state),
    data: getFilteredData(state),
    items: getCategoryItemsSubset(state),
    options: getOptions(state),
    details: getDetails(state),
    firstDate: getFirstHistoricalExposureDate(state),
    ...state.modules.securityProfileExposure,
    displayType: getDisplayType(state),
    exposureAttribution: getExposureAttributionData(state, props),
    maxFactors: getMaxFactors(state, props),
  }),
  actions: {
    ...Creators,
    setDate: PortfolioRootCreators.setProfileDate,
    resetDate: PortfolioRootCreators.resetProfileDate,
    openFactorProfile: ProfileCreators.openFactorProfile,
  },
})
